import { AdminLanesTable } from '../views/index';
import { LanesList } from '../dtos/index';

export const ADMIN_LANES_LIST_TABLE = (
	carrierList: Array<LanesList> = []
): Array<AdminLanesTable> => {
	let results: Array<AdminLanesTable> = [];
	try {
		if (carrierList.length > 0) {
			carrierList.map((lane) => {
				let row = {} as AdminLanesTable;
				row.destinationCity = lane.destCity;
				row.destinationState = lane.destState;
				row.destinationStates = lane.destinationStates;
				row.laneCount = lane.laneCount;
				row.originCity = lane.originCity;
				row.originState = lane.originState;
				row.trailerType = lane.trailerType;
				row.laneId = lane.laneId;
				results.push(row);
			});
		}
	} catch (error) {
		console.log('ADMIN_LANES_LIST_TABLE error: ', error);
	}

	return results;
};
